import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../../tas';
import { REIMAGINED_TAS_APPLICATION_INCLUDES } from 'tio-employee/utils/tas/reimagined-includes';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysTasApplicationsShowRoute extends Route {
  @service declare store: Store;
  @service declare reimaginedData: ReimaginedDataService;

  async model(params: Record<string, unknown>) {
    const applicationId = params['tas_application_id'] as string;

    // In demo mode, return a proxy object instead of fetching from the API
    if (this.reimaginedData.isDemoMode) {
      const demoProxy = this.reimaginedData.getDemoTasApplicationProxy(applicationId);
      if (demoProxy) {
        return {
          ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
          applicationId,
          application: demoProxy as unknown as TasApplicationModel,
        };
      }
    }

    const { content } = (await this.store.request(
      findRecord<TasApplicationModel>('tas-application', applicationId, {
        include: REIMAGINED_TAS_APPLICATION_INCLUDES.join(','),
        reload: true,
      })
    )) as { content: { data: TasApplicationModel } };

    return {
      ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
      applicationId,
      application: content.data,
    };
  }
}
